import { PropsWithChildren } from 'react';

import { cn } from '@shared/utils/helpers';

export function LicensePlate({ children }: PropsWithChildren<{}>) {
  if (!children) {
    return null;
  }

  return (
    <span
      className={cn(
        'relative uppercase text-red-500 font-mono font-medium inline-flex pl-4 pr-2 border-2 border-red-500 rounded',
        'before:w-2 before:bg-blue-500 before:absolute before:top-px before:bottom-px before:left-px before:rounded-l-sm'
      )}
    >
      {children}
    </span>
  );
}
